import React from 'react';
import { useRenderPDF } from '../hooks/use-render-pdf';
import { PdfGeneratorData } from '../pdf-generator';

export const PDFPreview = (props: PdfGeneratorData) => {
  const url = useRenderPDF(props);

  const src = url ? `${url}#toolbar=1` : null;

  if (!src) {
    return (
      <div
        style={{
          width: '100%',
          height: '100vh',
          background: 'rgb(82, 86, 89)',
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: 'var(--font-family-default)',
          gap: '12px'
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="spinner"
          style={{ marginTop: '24px' }}
        >
          <path d="M21 12a9 9 0 1 1-6.219-8.56" />
        </svg>
        <p>PDF wird generiert...</p>
      </div>
    );
  }

  return <iframe src={src} style={{ width: '100%', height: '100vh' }} />;
};
